NtechApp.JobsGridControls = function($view) {
    var me = this;

    this._$view = null;

    this._click = null;
    this._ajax = null;
    //this._loader = null;
    //this._overlay = null;

    this._construct = function() {
        me._$view = $view;

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        //me._loader = new NtechApp.Loader();
        //me._overlay = new NtechApp.Overlay();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-toggleJobActiveStatus]", function(event) {
            var $button = $(event.target);
            var modelId = $button.attr("data-toggleJobActiveStatus");

            me._toggleStatus.call(me, modelId, $button);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobsGridControls, {
    _enableLoader: function() {
        this._loader.on();
        this._overlay.on();
    },

    _disableLoader: function() {
        this._loader.off();
        this._overlay.off();
    },

    _toggleStatus: function(modelId, $button) {
        var me = this;
        //this._enableLoader();

        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate("business_job_toggle_active_status"),
                data: {modelId: modelId},
                onSuccess: function (data) {
                    me._updateStatusView($button, data.wasEnabled);

                    NtechApp.info.on(data.msg);
                    NtechApp.confirmForm.unload();
                },
                onComplete: function () {
                    //me._disableLoader();
                }
            });
        });
    },

    _updateStatusView: function($status, wasEnabled) {
        if(wasEnabled) {
            $status.text("Stop");
        }
        else {
            $status.text("Post");
        }
    }
});